import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "recurlyToken",
    initialState: null,
    reducers: {
        set: (state, action) => action.payload,
    },
});
